import { Button, chakra, Flex } from '@chakra-ui/react';

import { PagePadding } from '../../../style/constants';

export const NAVIGATION_CONTAINER_WIDTH = {
    base: 880,
    tablet: 1138,
    portrait: 880
};

export const NAVIGATION_BASE_VISIBLE_ITEM_COUNT = 4;

export const NAVIGATION_INFO_BUTTON_WIDTH = 56;

export const NAVIGATION_WRAPPER_HORIZONTAL_PADDING = 12;

export const NAVIGATION_INFO_BUTTON_GAP = 12;

export const NAVIGATION_TAB_LIST_WIDTH = {
    base: NAVIGATION_CONTAINER_WIDTH.base -
        NAVIGATION_INFO_BUTTON_WIDTH -
        NAVIGATION_WRAPPER_HORIZONTAL_PADDING -
        NAVIGATION_INFO_BUTTON_GAP,
    tablet: NAVIGATION_CONTAINER_WIDTH.tablet -
        NAVIGATION_INFO_BUTTON_WIDTH -
        NAVIGATION_WRAPPER_HORIZONTAL_PADDING -
        NAVIGATION_INFO_BUTTON_GAP,
    portrait: NAVIGATION_CONTAINER_WIDTH.portrait -
        NAVIGATION_INFO_BUTTON_WIDTH -
        NAVIGATION_WRAPPER_HORIZONTAL_PADDING -
        NAVIGATION_INFO_BUTTON_GAP
};

export const NAVIGATION_ITEM_WIDTH = {
    base: (NAVIGATION_TAB_LIST_WIDTH.base - NAVIGATION_WRAPPER_HORIZONTAL_PADDING) / NAVIGATION_BASE_VISIBLE_ITEM_COUNT,
    tablet: (NAVIGATION_TAB_LIST_WIDTH.tablet - NAVIGATION_WRAPPER_HORIZONTAL_PADDING) / NAVIGATION_BASE_VISIBLE_ITEM_COUNT,
    portrait: (NAVIGATION_TAB_LIST_WIDTH.portrait - NAVIGATION_WRAPPER_HORIZONTAL_PADDING) / NAVIGATION_BASE_VISIBLE_ITEM_COUNT
};

export const getNavigationTabListWidth = (visibleItemCount: number) => ({
    base: (NAVIGATION_ITEM_WIDTH.base * visibleItemCount) + NAVIGATION_WRAPPER_HORIZONTAL_PADDING,
    tablet: (NAVIGATION_ITEM_WIDTH.tablet * visibleItemCount) + NAVIGATION_WRAPPER_HORIZONTAL_PADDING,
    portrait: (NAVIGATION_ITEM_WIDTH.portrait * visibleItemCount) + NAVIGATION_WRAPPER_HORIZONTAL_PADDING
});

export const getNavigationWidth = (visibleItemCount: number) => {
    const tabListWidth = getNavigationTabListWidth(visibleItemCount);

    return {
        base: tabListWidth.base +
            NAVIGATION_INFO_BUTTON_WIDTH +
            NAVIGATION_WRAPPER_HORIZONTAL_PADDING +
            NAVIGATION_INFO_BUTTON_GAP,
        tablet: tabListWidth.tablet +
            NAVIGATION_INFO_BUTTON_WIDTH +
            NAVIGATION_WRAPPER_HORIZONTAL_PADDING +
            NAVIGATION_INFO_BUTTON_GAP
    };
};

export const ACTIVITY_TYPE_TABS_HEIGHT = {
    base: '48px',
    tablet: '64px',
    portrait: '48px'
};

export const NAVIGATION_GROUP_BUTTON_HEIGHT = {
    base: '40px',
    tablet: '48px',
    portrait: '40px'
};

export const container = chakra(Flex, {
    label: 'activity-type-tabs-container',
    baseStyle: {
        width: '100%',
        justifyContent: 'center',
        mb: '9px',
        paddingRight: {
            base: 6,
            tablet: PagePadding.right,
            portrait: 6
        },
        paddingLeft: {
            base: 6,
            tablet: PagePadding.left,
            portrait: 6
        }
    }
});

export const wrapper = chakra(Flex, {
    label: 'activity-type-tabs-wrapper',
    baseStyle: {
        background: 'rgba(255, 255, 255, 0.48)',
        position: 'relative',
        alignItems: 'center',
        padding: {
            base: '4px 6px',
            tablet: '1.5',
            portrait: '4px 6px'
        },
        width: NAVIGATION_CONTAINER_WIDTH,
        height: {
            base: '48px',
            tablet: 'auto',
            portrait: '48px'
        },
        borderRadius: '100px',
        border: '1px solid',
        borderColor: 'white.0'
    }
});

export const tabList = chakra(Flex, {
    label: 'activity-type-tabs-list',
    baseStyle: {
        position: 'relative',
        alignItems: 'center',
        flex: {
            base: `0 0 ${NAVIGATION_TAB_LIST_WIDTH.base}px`,
            tablet: `0 0 ${NAVIGATION_TAB_LIST_WIDTH.tablet}px`,
            portrait: `0 0 ${NAVIGATION_TAB_LIST_WIDTH.portrait}px`
        },
        minWidth: 0,
        width: NAVIGATION_TAB_LIST_WIDTH
    }
});

export const item = chakra(Button, {
    label: 'activity-type-tabs-item',
    baseStyle: {
        'padding': 'inherit',
        'borderRadius': '100px',
        'background': 'none',
        'width': '100%',
        'justifyContent': 'center',
        'alignItems': 'center',
        'textAlign': 'center',
        'height': NAVIGATION_GROUP_BUTTON_HEIGHT,
        'fontSize': {
            base: 'md',
            tablet: 'lg',
            portrait: 'md'
        },
        'fontWeight': 400,
        'marginRight': '11px',
        'cursor': 'pointer',
        '_hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.64)',
            borderRadius: '83px'
        },
        '&:nth-last-of-type(2)': {
            marginRight: 0
        }
    }
});

export const selectedButton = chakra(item, {
    label: 'activity-group-tabs-selected-button',
    baseStyle: {
        position: 'absolute',
        background: 'linear-gradient(104deg, #00ABE8 -2.03%, #007ACC 43.7%, #0063A7 105.46%)',
        color: 'white.0',
        fontWeight: 600,
        lineHeight: '130%',
        letterSpacing: '0.16px',
        borderRadius: '40px',
        boxShadow: '0 1px 3px 0 rgba(0, 25, 55, 0.16), 0 1px 2px 0 rgba(0, 25, 55, 0.06)',
        transition: 'left 0.25s ease-in',
        _hover: {
            background: 'linear-gradient(104deg, #00ABE8 -2.03%, #007ACC 43.7%, #0063A7 105.46%)'
        }
    }
});

export const infoButtonContainer = chakra(Flex, {
    label: 'activity-type-tabs-info-button-container',
    baseStyle: {
        alignItems: 'center',
        justifyContent: 'center',
        borderLeft: '1px solid',
        borderColor: 'primary.300',
        flex: `0 0 ${NAVIGATION_INFO_BUTTON_WIDTH}px`,
        h: '32px',
        marginLeft: `${NAVIGATION_INFO_BUTTON_GAP}px`
    }
});

export const infoButton = chakra(Button, {
    label: 'activity-type-tabs-info-button',
    baseStyle: {
        alignItems: 'center',
        backgroundColor: 'white.0',
        border: '1px solid',
        borderColor: 'primary.300',
        borderRadius: '50%',
        h: '32px',
        justifyContent: 'center',
        minWidth: '32px',
        p: 0,
        w: '32px',
        _hover: {
            backgroundColor: 'white.0'
        }
    }
});
